import {Button} from '@ui/buttons/button';
import {Trans} from '@ui/i18n/trans';
import {Link} from 'react-router';
import {Navbar} from '@common/ui/navigation/navbar/navbar';
import {Footer} from '@common/ui/footer/footer';
import imgUrl1 from './404-1.png';
import imgUrl2 from './404-2.png';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar menuPosition="header" />
      <div className="flex flex-1 flex-col-reverse items-center justify-center gap-40 px-16 py-64 md:gap-80 lg:flex-row lg:px-96">
        <div className="relative w-full text-center lg:w-1/2 lg:text-start">
          <div className="relative z-10">
            <h1 className="my-8 text-3xl font-bold text-main">
              <Trans message="Page Not Found" />
            </h1>
            <p className="my-16 text-muted">
              <Trans message="The page you're looking for doesn't exist or was removed" />
            </p>
            <Button
              className="my-8"
              elementType={Link}
              size="lg"
              to="/"
              variant="flat"
              color="primary"
            >
              <Trans message="Back to Home" />
            </Button>
          </div>
          <div className="absolute inset-0 dark:opacity-5">
            <img src={imgUrl2 as any} alt="" className="h-full w-full object-contain" />
          </div>
        </div>
        <div className="dark:opacity-80">
          <img src={imgUrl1 as any} alt="" />
        </div>
      </div>
      <Footer className="px-16 py-24" />
    </div>
  );
}
